export default __webpack_public_path__ + "static/InterDisplay-Italic-b3e32321ae4af23e440a094f80ac533f.woff";